module.exports = __webpack_public_path__ + "img/ranking_img_thee.1bb10556.png";